<template>
  <div class="page-container">
    <div class="page-header">
      <HeaderCom></HeaderCom>
    </div>
    <div class="scene-main">
      <el-tabs
        type="border-card"
        tab-position="left"
        style="height: calc(100vh - 300px);"
      >
        <el-tab-pane label="订单管理">
          <el-table :data="tableData" stripe height="600px">
            <el-table-column prop="oredersNum" label="订单编号">
            </el-table-column>
            <el-table-column prop="status" label="订单状态"> </el-table-column>
            <el-table-column prop="platform" label="平台"> </el-table-column>
            <el-table-column prop="country" label="国家"> </el-table-column>
            <el-table-column prop="shopUserName" label="店铺">
            </el-table-column>
            <el-table-column prop="client" label="顾客"> </el-table-column>
            <el-table-column
              prop="clientEmail"
              label="顾客邮箱"
            ></el-table-column>
            <el-table-column prop="address" label="收货地址"></el-table-column>
            <el-table-column prop="date" label="物流单号"></el-table-column>
            <el-table-column
              prop="createTime"
              label="下单时间"
            ></el-table-column>
            <el-table-column prop="amount" label="总金额">
              <template slot-scope="scope">
                <span>${{ scope.row.amount }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="财务列表">
          <div
            style="height: calc(-300px + 100vh);overflow: auto;padding: 0 10px;"
          >
            <img src="./1.png" alt="" />
            <img src="./2.png" alt="" />
            <img src="./3.png" alt="" />
            <img src="./4.png" alt="" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="假期模式">
          <div class="txt-t">
            1.什么是假期模式？
          </div>
          <div class="txt-b">
            亚马逊的假期模式是卖家因特殊情况导致在短时间内无法及时管理店铺的特殊模式，亚马逊假期模式允许卖家在假期期间暂时停用listing，不必担心负面反馈。简而言之，亚马逊的假期模式是暂停帐户，而不是关闭帐户。
          </div>
          <div class="txt-t">
            2 开启假期模式对卖家有什么影响？
          </div>
          <div class="txt-b">
            ①当卖家在开启假期模式之后，正在销售的商品会被暂时下架。
          </div>
          <div class="txt-b">
            ②可以有效避免假期内买家下单，解决店铺无法及时发货等问题。
          </div>
          <div class="txt-b">
            ③开启假期模式后FBM卖家无法获得订单，后期恢复到“可售状态”有可能影响排名和销量。
          </div>
          <div class="txt-t">
            3. 可设置假期模式的对象？ 亚马逊假期模式只针对FBM卖家。
          </div>
          <div class="txt-b">
            FBA卖家不用考虑这个模式，因为设置了也无效，listing
            还会显示在售。卖家仍需要确保账户一切正常运行，包括发货、检查库存绩效问题、回复买家留言等。
            由此可以得出结论：不管是是FBM还是FBA卖家，假期模式只是短时间避免买家下单，对于长期不运营的站点显然还是直接关闭的好，因为现在因为其他不运营的站点导致二审和二次视频认证的很对很多，二审还稍微好解决一点，找靠谱一点的服务商还是能过，但是二次视频认证，特别是加强版的那种，目前能过的凤毛麟角。所以为了以防后患，还是应该过段关闭掉不运营的站点。
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-drawer
        size="50%"
        title="我是标题"
        :visible.sync="drawer"
        :with-header="false"
      >
        <div style="padding: 20px;">
          <el-form
            label-position="top"
            ref="form"
            :model="form"
            label-width="80px"
          >
            <el-form-item
              label="【1】 在财务状况出现赤字的情况下，您打算采取哪些措施来应对？"
            >
              <el-checkbox-group v-model="form.type1">
                <el-checkbox
                  label="开源节流，寻找降低成本和提高效率的方法，如优化供应链、减少不必要的开支。"
                  name="type"
                ></el-checkbox>
                <el-checkbox
                  label="继续扩大投入，通过增加市场投入或产品研发来挽回赤字。"
                  name="type"
                ></el-checkbox>
                <el-checkbox
                  label="暂停扩张计划，削减非必要的支出，以节省资金。"
                  name="type"
                ></el-checkbox>
                <el-checkbox
                  label="寻求外部融资支持，如向银行申请贷款或寻找投资者。"
                  name="type"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="【2】面对供应商提前要求付款的情况，您打算采取何种措施来应对？"
            >
              <el-checkbox-group v-model="form.type2">
                <el-checkbox
                  label="与供应商协商延迟付款时间或分期付款，以缓解资金压力。"
                  name="type2"
                ></el-checkbox>
                <el-checkbox
                  label="寻找其他供应商替代，选择与资金情况更相符合的合作伙伴。"
                  name="type2"
                ></el-checkbox>
                <el-checkbox
                  label="拒绝供应商的要求，寻找其他筹资渠道以解决资金短缺。"
                  name="type2"
                ></el-checkbox>
                <el-checkbox
                  label="接受供应商的要求，但同时寻求客户提前付款以维持现金流平衡。"
                  name="type2"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="【3】面对税收政策变化的情况，您打算采取哪些措施来应对？"
            >
              <el-checkbox-group v-model="form.type3">
                <el-checkbox
                  label="寻求专业财务顾问的建议，评估新政策对企业财务状况的影响，并制定相应的调整方案。"
                  name="type3"
                ></el-checkbox>
                <el-checkbox
                  label="继续按照既定的财务策略运营，暂不做出调整，观望政策的具体执行效果。"
                  name="type3"
                ></el-checkbox>
                <el-checkbox
                  label="加大税收优惠的利用，尽量减少税负，以提高盈利能力。"
                  name="type3"
                ></el-checkbox>
                <el-checkbox
                  label="调整产品定价或销售策略，以应对税收政策变化对产品成本和价格的影响。"
                  name="type3"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="【4】面对某产品的持续下滑销量，您计划采取哪些措施来应对？"
            >
              <el-checkbox-group v-model="form.type4">
                <el-checkbox
                  label="重新评估产品定价和市场定位，考虑调整价格或寻找新的销售渠道。"
                  name="type4"
                ></el-checkbox>
                <el-checkbox
                  label="增加市场推广力度，提高产品的知名度和曝光度。"
                  name="type4"
                ></el-checkbox>
                <el-checkbox
                  label="优化产品质量和服务，以提升客户满意度和口碑。"
                  name="type4"
                ></el-checkbox>
                <el-checkbox
                  label="暂时停产该产品，转向研发新产品线。"
                  name="type4"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="【5】面对某个销售渠道的订单量突然增加的情况，您打算采取何种措施来应对？"
            >
              <el-checkbox-group v-model="form.type5">
                <el-checkbox
                  label="增加库存备货量，以应对订单销售量的增长，避免库存不足影响销售。"
                  name="type5"
                ></el-checkbox>
                <el-checkbox
                  label="优化订单处理流程，加强供应链和物流配送能力，确保订单能够及时准确地配送到客户手中。"
                  name="type5"
                ></el-checkbox>
                <el-checkbox
                  label="调整价格或促销策略，以提高销售量的同时保持盈利。"
                  name="type5"
                ></el-checkbox>
                <el-checkbox
                  label="拒绝订单或减少销售渠道的运营范围，以控制订单量并保证服务质量。"
                  name="type5"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="【6】某产品在特定地区的销售量远超预期的情况下，您计划采取哪些措施来扩大该地区市场份额？"
            >
              <el-checkbox-group v-model="form.type6">
                <el-checkbox
                  label="加大市场营销和推广力度，提高产品在该地区的知名度和市场占有率。"
                  name="type6"
                ></el-checkbox>
                <el-checkbox
                  label="增加供货量，确保能够满足该地区的市场需求，以提高客户满意度。"
                  name="type6"
                ></el-checkbox>
                <el-checkbox
                  label="优化产品定位和品牌形象，以迎合该地区消费者的偏好和需求。"
                  name="type6"
                ></el-checkbox>
                <el-checkbox
                  label="拓展销售渠道，如增加零售店铺或线下销售点，以覆盖更多潜在客户。"
                  name="type6"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
      <div class="foot">
        <div class="submit-btnn">
          <button class="" @click="drawer = true">
            <div class="text">
              运营总结
            </div>
            <div class="subText">
              Merchandise on the shelves
            </div>
          </button>
          <button class="" @click="toNextRouter">
            <div class="text">
              下一步
            </div>
            <div class="subText">
              Merchandise on the shelves
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderCom from "@/components/headerCom";
import { orderList } from "./orderList";
export default {
  data() {
    return {
      tableData: orderList.items,
      drawer: false,
      form: {
        type1: [],
        type2: [],
        type3: [],
        type4: [],
        type5: [],
        type6: [],
      },
    };
  },
  components: {
    HeaderCom,
  },
  methods: {
    toNextRouter() {
      this.$router.push({
        path: "/simulationResult",
        query: this.$route.query,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@mixin title {
  padding-bottom: 0;
  margin-bottom: 10px;
  .text {
    font-size: 26px;
    font-weight: bold;
    line-height: 33px;
  }
  .subText {
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    color: #999999;
  }
}

.page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100vw;
  min-height: 100vh;
  background: url("./../../assets/image/simulation/bg.jpg");
  background-size: cover;
  padding-top: 60px;
  .page-header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 60px;
    background: #005be7;
    padding: 0 20px;
    z-index: 2001;
  }
  .scene-main {
    width: calc(100% - 280px);
    height: calc(100vh - 180px);
  }
}
.foot {
  margin-top: 30px;
  .submit-btnn {
    display: flex;
    justify-content: right;
    button {
      width: 200px;
      height: 64px;
      background: linear-gradient(90deg, #70a0eb 0%, #005be7 100%);
      box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
      opacity: 1;
      border-radius: 60px;

      &.left {
        border-radius: 60px 0 0 60px;
      }

      &.right {
        border-radius: 0 60px 60px 0;
      }

      .text {
        font-size: 22px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        line-height: 26px;
        color: #ffffff;
      }

      .subText {
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
        color: #ffffff;
      }
    }
  }
}
.txt-t {
  font-size: 16px;
  margin-bottom: 6px;
}
.txt-b {
  font-size: 14px;
  margin-bottom: 6px;
}
</style>
